import api from './api';

export interface Animation {
  id: number;
  title: string;
  html_content: string;
  tags: string[];
  created_by: number;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  is_public: boolean;
  can_edit: boolean;
  order: number;
  container: number | null;
}

class AnimationService {
  async getAll(params?: any): Promise<Animation[]> {
    const response = await api.get('/animations/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async get(id: number): Promise<Animation> {
    const response = await api.get(`/animations/${id}/`);
    return response.data;
  }

  async create(data: Partial<Animation>): Promise<Animation> {
    const response = await api.post('/animations/', data);
    return response.data;
  }

  async update(id: number, data: Partial<Animation>): Promise<Animation> {
    const response = await api.patch(`/animations/${id}/`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/animations/${id}/`);
  }

  async duplicate(id: number): Promise<Animation> {
    const response = await api.post(`/animations/${id}/duplicate/`);
    return response.data;
  }

  async reorder(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/animations/reorder/', { items });
  }
}

const animationService = new AnimationService();
export default animationService;
